module.exports = __webpack_public_path__ + "static/img/yangyin.af1a187.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/yangyin.jpg
// module id = O/bs
// module chunks = 1